webpackJsonp([145],{

/***/ 2905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    'base-checkbox': function baseCheckbox() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 503));
    },
    'base-select': function baseSelect() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 499));
    },
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124));
    }
  },
  props: {
    value: [Boolean],
    isBillable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      selectedBillableEntity: null,
      noChargeCheckboxValue: false,
      noChargeOptions: [],
      noChargeSelectedReason: null,
      billingEntities: []
    };
  },

  methods: {
    consolidate: function consolidate() {
      this.visible = false;
      if (this.isBillable && !this.selectedBillableEntity) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-select-billable-entity'));
      } else if (this.isBillable && this.noChargeCheckboxValue && !this.noChargeSelectedReason) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-specify-not-charge-reason'));
      } else {
        this.$emit('consolidate', { BillingEntityId: this.selectedBillableEntity, NoChargeReasonId: this.noChargeSelectedReason });
      }
    },
    noChargeToggled: function noChargeToggled() {
      var _this = this;

      if (!this.noChargeCheckboxValue && this.noChargeOptions.length === 0) {
        this.$api('NoChargeReasons').then(function (response) {
          _this.noChargeOptions = response.data.data;
        });
      }
    },
    loadBillableEntities: function loadBillableEntities() {
      var _this2 = this;

      if (this.billingEntities.length === 0) {
        this.$api('webapp/BillingEntities').then(function (response) {
          _this2.billingEntities = response.data.data;
        });
      }
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    noChargeSelectedReasonIsTechnicalType: function noChargeSelectedReasonIsTechnicalType() {
      return this.noChargeSelectedReason ? this.noChargeSelectedReason.value === 1 || this.noChargeSelectedReason.value === 4 : false;
    }
  }
});

/***/ }),

/***/ 3117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(2905);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(3120);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3118)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/shared/ConsolidateAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72bd54cf", Component.options)
  } else {
    hotAPI.reload("data-v-72bd54cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3118:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f8f9eb96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3119:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.modal-content{-webkit-transition:all linear 2.5s;transition:all linear 2.5s\n}\n", ""]);

// exports


/***/ }),

/***/ 3120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.$t("consolidate-modal.title")
      },
      on: { show: _vm.loadBillableEntities },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { white: "", shadow: "" },
                      on: { click: _vm.consolidate }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.isBillable
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("consolidate-modal.charge-with-data")))
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    disabled: _vm.noChargeSelectedReasonIsTechnicalType,
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-billable-entity"
                    ),
                    options: _vm.billingEntities
                  },
                  model: {
                    value: _vm.selectedBillableEntity,
                    callback: function($$v) {
                      _vm.selectedBillableEntity = $$v
                    },
                    expression: "selectedBillableEntity"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { onInput: _vm.noChargeToggled },
                    model: {
                      value: _vm.noChargeCheckboxValue,
                      callback: function($$v) {
                        _vm.noChargeCheckboxValue = $$v
                      },
                      expression: "noChargeCheckboxValue"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("consolidate-appointment-modal.no-charge")
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("base-select", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noChargeCheckboxValue,
                      expression: "noChargeCheckboxValue"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-no-charge-reason"
                    ),
                    options: _vm.noChargeOptions
                  },
                  model: {
                    value: _vm.noChargeSelectedReason,
                    callback: function($$v) {
                      _vm.noChargeSelectedReason = $$v
                    },
                    expression: "noChargeSelectedReason"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bd54cf", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/145.c9b20e45d561e0564d70.js